import PropTypes from 'prop-types'

export const FacetShape = PropTypes.shape({
  /// ?
})
